module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('menu', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v("На главную")]), _vm._v(" /\n    "), _c('router-link', {
    attrs: {
      "to": "/page2"
    }
  }, [_vm._v("На внутреннюю")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-46058350"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/Menu.vue
// module id = 97
// module chunks = 0